<template>
<div>
  <h2>
    We have everything we need!
  </h2>

  <p class="macro-final-step">
    Click "Finish" to check out your ideal balance of macros to meet your current goals. Check in periodically to assess if you need to make adjustments as
    your goals, fitness status, or weight may change.
  </p>
</div>
</template>

<script>
import store from '@state/store';
import Vue from 'vue';
import { macroCalculatorComputed, macroCalculatorMethods } from '@state/helpers';

export default {
  props: ['clickedNext', 'currentStep'],
  data() {
    return {};
  },
  components: {},
  computed: {
    ...macroCalculatorComputed,
    BMI() {
      return (this.weight / this.height ** 2) * 703;
    },
    // Current calories values are represented by calories variable in the code because we are using
    // this set method (setMacrosCalories($event.target.value);) to save the form value of the current calories
    caloriesPerPound() {
      return this.calories / this.targetWeight;
    },
    proteinMultiplier() {
      if (this.caloriesPerPound < 10) {
        return 0.8;
      }
      if (this.caloriesPerPound >= 10 && this.caloriesPerPound < 11) {
        return 1.0;
      }
      if (this.caloriesPerPound >= 11 && this.caloriesPerPound < 14.0) {
        return 1.2;
      }
      if (this.caloriesPerPound >= 14.0) {
        return 1.4;
      }
    },
  },
  mounted() {
    this.$emit('can-continue', { value: true });
    this.setMacrosFat(this.fatF());
    this.setMacrosProtein(this.proteinF());
    this.setMacrosCarbs(this.carbsF());
  },
  methods: {
    ...macroCalculatorMethods,
    proteinF() {
      return this.targetWeight * this.proteinMultiplier;
    },
    fatF() {
      return this.targetWeight * this.fatMultipliers(this.bodyTypeValue, this.goalSelectionIndex);
    },
    carbsF() {
      const fatCalories = this.fatF() * 9; // 9 is the number of calories per gram of fat
      const proteinCalories = this.proteinF() * 4; // 4 is the number of calories per gram of protein and carbs
      const remainingCalories = this.calories - fatCalories - proteinCalories;
      return remainingCalories / 4;
    },
    fatMultipliers(bodyShape, goalIndex) {
      if (this.caloriesPerPound >= 10.0) {
        const options = {
          ectomorph: [0.35, 0.4, 0.45],
          mesomorph: [0.4, 0.45, 0.53],
          endomorph: [0.43, 0.5, 0.55],
        };
        if (this.BMI > 30) {
          return options['endomorph'][goalIndex];
        } else {
          return options[bodyShape][goalIndex];
        }
      } else {
        return 0.3;
      }
    },
  },
  watch: {
    $v: {
      deep: true,
      handler: function(val) {
        this.$emit('can-continue', { value: true });
      },
    },
    clickedNext(val) {},
    currentStep() {
      // Final confirmation step so let's allow users to continue
      this.$emit('can-continue', { value: true });
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.cdc-container {
  margin-bottom: 2rem;
}

.macro-final-step {
  font-size: 1.7rem;
  line-height: 1.2;
  margin-bottom: 3rem;
  margin-top: 1.6rem;
}
</style>
